export default __webpack_public_path__ + "static/media/returns.a2bdad06.svg";